var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)",
    stroke: "#88456E",
    strokeWidth: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.265,
    cy: 4.617,
    rx: 4.111,
    ry: 4.212
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.089 21.305c4.472 0 8.543-1.808 8.276-3.45-.525-3.223-4.427-8.215-7.967-8.215-3.518 0-7.284 4.852-7.97 8.23-.34 1.676 3.27 3.435 7.66 3.435z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.633,
    cy: 20.37,
    rx: 10.227,
    ry: 3.259
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountHover);
export default __webpack_public_path__ + "static/media/account-hover.f0cc585dcd4a77d44f543aaf30fbce3a.svg";
export { ForwardRef as ReactComponent };